// @ts-nocheck
// Vendored from roblouie/gameboy-emulator with one MultiNostalgia
// patch (see ../../PATCHES.md): no longer extends the browser-only
// `ImageData` class — extending it crashes at module load in Node.
// The shape consumers care about (width, height, data, setPixel) is
// preserved.
export class EnhancedImageData {
    width;
    height;
    data;
    constructor(width, height) {
        this.width = width;
        this.height = height;
        this.data = new Uint8ClampedArray(width * height * 4);
    }
    setPixel(x, y, red, green, blue, alpha = 255) {
        const pixelStart = (y * this.width * 4) + (x * 4);
        this.data[pixelStart] = red;
        this.data[pixelStart + 1] = green;
        this.data[pixelStart + 2] = blue;
        this.data[pixelStart + 3] = alpha;
    }
}
//# sourceMappingURL=enhanced-image-data.js.map